import { module } from 'stereomodularjs';
import * as CookieConsent from "vanilla-cookieconsent";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        CookieConsent.run({
            categories: {
                necessary: {
                    enabled: true,  // this category is enabled by default
                    readOnly: true  // this category cannot be disabled
                },
                analytics: {}
            },

            language: {
                default: 'en',
                translations: {
                    en: {
                        consentModal: {
                            title: 'We use cookies',
                            description: 'To provide the best experiences, we use technologies like cookies to store and/or access device information. Consenting to these technologies will allow us to process data such as browsing behavior or unique IDs on this site. Not consenting or withdrawing consent, may adversely affect certain features and functions.',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            showPreferencesBtn: 'Manage Individual preferences'
                        },
                        preferencesModal: {
                            title: 'Manage cookie preferences',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            savePreferencesBtn: 'Accept current selection',
                            closeIconLabel: 'Close modal',
                            sections: [
                                {
                                    title: 'Cookie Policy',
                                    description: 'This website uses cookies to enhance your browsing experience and provide personalized content.'
                                },
                                {
                                    title: 'Strictly Necessary cookies',
                                    description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',

                                    //this field will generate a toggle linked to the 'necessary' category
                                    linkedCategory: 'necessary'
                                },
                                {
                                    title: 'Performance and Analytics',
                                    description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                                    linkedCategory: 'analytics'
                                },
                                {
                                    title: 'More information',
                                    description: 'For any queries regarding our cookie policy and your choices, please <a href="#contact-page">contact us</a>'
                                }
                            ]
                        }
                    },
                    fr: {
                        consentModal: {
                            title: 'Nous utilisons des cookies',
                            description: 'Pour offrir les meilleures expériences, nous utilisons des technologies telles que les cookies pour stocker et/ou accéder aux informations des appareils. Le fait de consentir à ces technologies nous permettra de traiter des données telles que le comportement de navigation ou les ID uniques sur ce site. Le fait de ne pas consentir ou de retirer son consentement peut avoir un effet négatif sur certaines caractéristiques et fonctions.',
                            acceptAllBtn: 'Accepter tout',
                            acceptNecessaryBtn: 'Tout refuser',
                            showPreferencesBtn: 'Gérer les préférences individuelles'
                        },
                        preferencesModal: {
                            title: 'Gérer les préférences en matière de cookies',
                            acceptAllBtn: 'Accepter tout',
                            acceptNecessaryBtn: 'Tout refuser',
                            savePreferencesBtn: 'Accepter la sélection actuelle',
                            closeIconLabel: 'Fermer la modal',
                            sections: [
                                {
                                    title: 'Politique de cookies',
                                    description: 'Ce site Web utilise des cookies pour améliorer votre expérience de navigation et fournir du contenu personnalisé.'
                                },
                                {
                                    title: 'Cookies strictement nécessaires',
                                    description: 'Ces cookies sont essentiels au bon fonctionnement du site Web et ne peuvent pas être désactivés.',

                                    //this field will generate a toggle linked to the 'necessary' category
                                    linkedCategory: 'necessary'
                                },
                                {
                                    title: 'Performance et analytique',
                                    description: 'Ces cookies collectent des informations sur la façon dont vous utilisez notre site Web. Toutes les données sont anonymisées et ne peuvent pas être utilisées pour vous identifier.',
                                    linkedCategory: 'analytics'
                                },
                                {
                                    title: 'Plus d\'informations',
                                    description: 'Pour toute question concernant notre politique de cookies et vos choix, veuillez <a href="#contact-page">nous contacter</a>'
                                }
                            ]
                        }
                    }
                }
            },
            onModalShow: () => {
                const pm = document.querySelector('.pm.pm--box');
                if (pm) {
                    pm.setAttribute('data-lenis-prevent', 'true');
                }
            }
        });
        CookieConsent.setLanguage(document.querySelector('html').lang.substr(0,2),true );
        // console.log(document.querySelector('html').lang.substr(0,2));
    }
    destroy() {

    }
}